import { API } from "./API.js"
import axios from "axios"

const url = API + "/wines_search2/"
const debug = true

class Wines_Search {
  static search(postdata) {
    return axios
      .post(url, postdata)
      .then(response => {
        if (debug) console.log("Wines_Search.search: ", response.data)

        return {
          count: response.data.count || 0,
          list: Array.isArray(response.data.list) ? response.data.list : []
        }
      })
      .catch(error => {
        console.log("Wines_Search.search error:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data
        })

        return {
          count: 0,
          list: []
        }
      })
  }
}

export default Wines_Search